import React, { Component } from 'react';
import { Table, Divider, Tag, Icon, Button, Card, Row, Col } from 'antd';


export default class Card4 extends Component {

    constructor(props) {
        super(props);

        this.state = {

        };

    }

    render() {
        const { title, detail, createdate, expiredate } = this.props;

        return (
            <Card className="card1" >
                <Row gutter={16} style={{ marginTop: 30 }}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Row gutter={16} type="flex" justify="center">
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <div className="card1-head">
                                    <h1>{title}</h1>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Row gutter={16} type="flex" justify="center" style={{ marginTop: 10, textAlign: 'center' }}>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <label className="ants-gray-low">{detail}</label>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ textAlign: 'center' }}>
                        <div className="text-muted" style={{ textAlign: "center" }}>
                            <label className="card4-footer" style={{ marginRight: 5 }}>
                                Last Add : &nbsp; {createdate} &nbsp;
                                <span className="antsicon-navigator card4-footer"></span>
                                &nbsp; Expire : &nbsp; {expiredate}
                            </label>
                        </div>
                    </Col>
                </Row>
            </Card>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/Ants/Card/Card4.js